import { Action } from './core/action';

export class PayByBillAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/common/actions/pay-by-bill.action.ts